import * as THREE from "three";
import { scene } from "./scene";
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
import { ControlFunction } from "./controlFunction";
const loader = new GLTFLoader();
import { progressbar, modelsLoaded } from "./progressbar";

const loadTapisRoulant = () => {
  const promiseTapisRoulant = new Promise((resolve, reject) => {
    loader.load(
      "office/model/tapis/tapis.gltf",
      function (tapisRoulant) {
        scene.add(tapisRoulant.scene);
        const tapisRoulantMesh = tapisRoulant.scene;

        tapisRoulantMesh.position.set(
          6.222733510579022, 1.3474502465832434, 4.8442149269604915
        );
        tapisRoulantMesh.rotation.set(
          3.141592653589793, -1.5676630803470242, 3.141592653589793
        );





        tapisRoulantMesh.scale.set(1.312, 1.312, 1.312);

        tapisRoulantMesh.traverse(function (object) {
          if (object.isMesh) {
            object.castShadow = true;
            object.receiveShadow = false;
          }
        });


        //ControlFunction(tapisRoulantMesh);
        resolve(tapisRoulantMesh);
        progressbar();
      },
      undefined,
      function (error) {
        console.error(error);
      }
    );
  });
  return promiseTapisRoulant;
};

export { loadTapisRoulant };
